import * as React from 'react'

interface IconProps {
	size?: number
	color?: string
	className?: string
}

export const TextAlignCenterIcon = ({ size = 24, color = 'currentColor', className }: IconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		className={className}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<line x1="4" y1="6" x2="20" y2="6" />
		<line x1="8" y1="12" x2="16" y2="12" />
		<line x1="6" y1="18" x2="18" y2="18" />
	</svg>
)
